<script setup>
import {ref, onBeforeMount, onMounted, computed} from 'vue'
import {useNetworkStore} from "../stores/network"
import seriousQuiz from '../data/serious.json'
import {SpinePlayer} from '@esotericsoftware/spine-player'
import bgMusic from '../assets/bg-music.mp3'
import sndClick from '../assets/click.mp3'
import sndArrowClick from '../assets/arrow_click.mp3'
import feedbackPositiveSnd from '../assets/feedback_positif.mp3'
import feedbackNegativeSnd from '../assets/feedback_negatif.mp3'
import finalScreen from '../assets/final_screen.mp3'


import goodImg from '../assets/Score-top.png'
import midImg from '../assets/Score-moyen.png'
import badImg from '../assets/Score-nul.png'

const QUESTION = 'question'
const FEEDBACK = 'feedback'
const RESULT = 'result'
const INTRO = 'intro'

const WIDTH = 1280
const HEIGHT = 720


// DEMO MODE DEMO MODE DEMO MODE DEMO MODE DEMO MODE
const demo = false

const network = useNetworkStore()

const score = ref(0)


const currentStep = ref(INTRO)

const questions = {}
const questionIndex = ref(1)
const totalQuestions = ref(Object.keys(seriousQuiz).length)

const positiveFeedback = ref(false)
const choicePicked = ref(null)

const spinePlayer = ref(null)
const spinePlayerFeedback = ref(null)
const spinePlayerFeedbackSquid = ref(null)
const spinePlayerIntroSquid = ref(null)

const music = new Audio(bgMusic)
const click = new Audio(sndClick)
const arrowClick = new Audio(sndArrowClick)
const sndGood = new Audio(feedbackPositiveSnd)
const sndBad = new Audio(feedbackNegativeSnd)
const sndFinal = new Audio(finalScreen)

const scoreMessages = {
  high: "SUPER! Vous connaissez tous les trucs et astuces pour gérer la climatisation de votre maison de façon intelligente! Partagez vos connaissances et testez vos amis!",
  mid: "Bravo, vous avez dejà quelques connaissances en la matière. Et vous pouvez encore vous améliorez! N'hésitez pas à revoir les conseils de Sam et Nathalie. Et puis comparez avec vos amis et collègues!",
  low: "Il n'y a pas de doutes, vous pouvez vous améliorer! Une bonne gestion de la climatisation de votre maison et de son environnement, vous feront faire des économies d'énergie! Allez sans tarder voir les conseils de Sam et Nathalie! Et puis faites tester le jeu par vos amis!"
}

const scoreMessageTitles = {
  high: "Vous êtes un expert!",
  mid: "Vous êtes sur la bonne voie!",
  low: "Vous pouvez vous améliorer!"
}

const scoreMessage = ref('')
const scoreMessageTitle = ref('')

let elem;

const scoreImg = computed(() => {
  if (score.value > 6) {
    return goodImg
  } else if (score.value > 4) {
    return midImg
  } else {
    return badImg
  }
})

const getScoreMessage = () => {
  if (score.value > 6) {
    return [scoreMessages.high, scoreMessageTitles.high]
  } else if (score.value > 4) {
    return [scoreMessages.mid, scoreMessageTitles.mid]
  } else {
    return [scoreMessages.low, scoreMessageTitles.low]
  }
}

//todo record already taken questions
onBeforeMount(() => {
  if (demo) {
    questions['1'] = seriousQuiz['1']['items'][0]
    questions['2'] = seriousQuiz['1']['items'][1]
    questions['3'] = seriousQuiz['1']['items'][2]
    totalQuestions.value = 3
  } else {
    pickRandomQuestionFromTheme()
  }
})

onMounted(() => {
  loadSpinePlayer("spinePlayer", true)
  loadSpinePlayer("spinePlayerFeedback", false)
  loadSpinePlayer("spinePlayerFeedbackSquid", false, true)
  spinePlayerIntroSquid.value = loadSpinePlayer("spinePlayerIntroSquid", false, true)
  setContainerBackground(questions[questionIndex.value].background)

  doResize()
  window.addEventListener('resize', doResize)

  music.loop = true
  // music.play()

  elem = document.querySelector("#intro-container");
  document.addEventListener("mousemove", parallax);

  network.sendStartGame({type:'serious'})
})

const pickRandomQuestionFromTheme = () => {
  Object.keys(seriousQuiz).forEach((theme) => {
    const randomQuestion = Math.floor(Math.random() * seriousQuiz[theme]['items'].length)
    questions[theme] = seriousQuiz[theme]['items'][randomQuestion]
  })
}

const answerPicked = (choice) => {
  // points.value += parseInt(choice.points)
  // const positive = choice.points > 0
  choicePicked.value = choice
  click.play()

  let networkScore = 0

  if (choice.spine_skin !== 'pieuvre') {
    changeSpineFeedbackSkin(choice.spine_skin)
    sndBad.play()
  } else {
    score.value += 1
    sndGood.play()
    networkScore = 1
  }

  setContainerBackground(choice.background)
  displayFeedback(true)

  network.sendAnswer({question:questions[questionIndex.value].id, answer: networkScore})

}

const showNextQuestion = () => {
  if (questionIndex.value === totalQuestions.value) {
    console.log('end of quiz')
    displayResult()
    return
  }

  questionIndex.value += 1
  changeSpineSkin(questions[questionIndex.value].spine_skin)
  setContainerBackground(questions[questionIndex.value].background)
  isLeft.value = false
  displayFeedback(false)
}

const displayFeedback = (display) => {
  if (display) {
    currentStep.value = FEEDBACK
    music.volume = 1
  } else {
    currentStep.value = QUESTION
    playSoundImmediate(arrowClick)
  }
}

const displayResult = () => {
  const [message, title] = getScoreMessage()
  scoreMessage.value = message
  scoreMessageTitle.value = title
  currentStep.value = RESULT
  sndFinal.play()
}

const loadSpinePlayer = (parent, flip, squid) => {
  let jsonUrl = '/static/vendors/chars/humans.json'
  let atlasUrl = '/static/vendors/chars/humans.atlas.txt'
  let animation = "list_thumb_up"
  let skin = "sam_list_thumb_up"

  if (squid) {
    jsonUrl = '/static/vendors/chars/squid.json'
    atlasUrl = '/static/vendors/chars/squid.atlas.txt'
    animation = "pieuvre"
    skin = "pieuvre"
  }

  const spine = new SpinePlayer(parent, {
    jsonUrl,
    atlasUrl,
    animation,
    skin,
    showControls: false,
    premultipliedAlpha: true,
    alpha: true,
    backgroundColor: '#00000000',
    preserveDrawingBuffer: true,
    defaultMix: 0,
    // viewport: {
    //   x: 0,
    //   y: 0,
    //   width: 4000,
    //   height: 2500,
    //   padLeft: 0,
    //   padRight: 0,
    //   padTop: 0,
    //   padBottom: 0
    // },
    success: (player) => {
      if (squid) {
        spinePlayerFeedbackSquid.value = player
      } else {
        if (flip) {
          player.skeleton.scaleX = -1
          spinePlayer.value = player
        } else {
          spinePlayerFeedback.value = player

        }
      }
    },
  })

  return spine
}

const changeSpineSkin = (skin) => {
  setSkin(skin, spinePlayer)
}

const changeSpineFeedbackSkin = (skin) => {
  setSkin(skin, spinePlayerFeedback)
}

const setSkin = (skin, player) => {
  const skinData = findSkinOrDefault(skin)

  player.value.skeleton.setSkin(skinData.skin)
  player.value.skeleton.setSlotsToSetupPose()
  player.value.setAnimation(skinData.animation, true)
}

const findSkinOrDefault = (skin) => {
  const character = skin.split('_')[0]
  const animationName = skin.split('_').splice(1).join('_')

  const skinData = spinePlayer.value.skeleton.data.findSkin(skin)
  if (skinData) {
    return {skin: skinData, animation: animationName}
  }

  console.warn(`skin ${skin} not found, loading default`)
  if (character === 'nathalie') {
    return {
      skin: spinePlayer.value.skeleton.data.findSkin('nathalie_neutral'),
      animation: 'neutral'
    }
  }
  return {
    skin: spinePlayer.value.skeleton.data.findSkin('sam_idle'),
    animation: 'idle'
  }
}

const playSoundImmediate = (sound) => {
  sound.currentTime = 0
  sound.play()
}

const setContainerBackground = (background) => {
  document.querySelector('.container-game').style.backgroundImage = `url('/static/vendors/bg/${background}.jpg')`
}

const isLeft = ref(false)
const slideLeft = () => {
  isLeft.value = !isLeft.value
  if (isLeft.value) {
    music.volume = 0.4
  } else {
    music.volume = 1
  }
  // await new Promise(r => setTimeout(r, 2000))
  // isLeft.value = false
  playSoundImmediate(arrowClick)
}


function doResize() {
  let gameContainer = document.getElementById('seriousPage')
  let gameContainerHeight = 720//gameContainer.getBoundingClientRect().height
  let gameContainerWidth = 1280//gameContainer.getBoundingClientRect().width

  let parentContainer = document.getElementById('serious') // in parent component

  let scale
  let scrollOffset
  let listenerSet = false

  scale = Math.min(
      window.innerWidth / gameContainerWidth,
      window.innerHeight / gameContainerHeight
  )
  // let scale = Math.min(
  //     $wrapper.width() / gameContainerWidth,
  //     $wrapper.height() / gameContainerHeight
  // )

  gameContainer.style.transform = `translate(-50%, -50%) scale(${scale})`

  // console.log('window.innerWidth, window.innerHeight', window.innerWidth, window.innerHeight)
  // console.log('gameContainerWidth, gameContainerHeight', gameContainerWidth, gameContainerHeight)
  // console.log('window.innerWidth / gameContainerWidth, window.innerHeight / gameContainerHeight', window.innerWidth / gameContainerWidth, window.innerHeight / gameContainerHeight)
  // console.log('scale', scale)

  let containerScaled = gameContainerHeight * scale
  scrollOffset = getComputedStyle(parentContainer, null).height - containerScaled
  if (scrollOffset > 0) {
    setTimeout(() => window.scrollTo(0, scrollOffset / 2), 50)
    if (!listenerSet) {
      window.addEventListener("scroll", preventMotion, false);
      window.addEventListener("touchmove", preventMotion, false);
      listenerSet = true
    }
  }
}

function preventMotion(event) {
  window.scrollTo(0, scrollOffset / 2);
  event.preventDefault();
  event.stopPropagation();
}


const restartQuiz = () => {
  window.location.reload()
}

function startGame() {
  currentStep.value = QUESTION
  playSoundImmediate(arrowClick)
  if (music.paused) {
    music.play()
  }
}


function parallax(e) {
  let _w = window.innerWidth / 2;
  let _h = window.innerHeight / 2;
  let _mouseX = e.clientX;
  let _mouseY = e.clientY;
  let _depth1 = `${50 + (_mouseX - _w) * 0.01}% ${50 + (_mouseY - _h) * 0.01}%`;
  let x = `${_depth1}`;
  elem.style.backgroundPosition = x;
}
</script>

<template>
  <div class="serious-page" id="seriousPage">
    <div class="container-game">
      <div id="spinePlayer">
      </div>
      <div class="question-container" :class="{'slide-left': isLeft}" v-if="currentStep === QUESTION">
        <div class="wave-left">
          <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
            <path d="M213.19,0.00 C0,68.59 600.48,84.38 202.98,150.00 L500.00,150.00 L500.00,0.00 Z"
                  style="stroke: none; fill: #fff;"></path>
          </svg>
        </div>
        <div class="question">
          <div class="question-text">
            <div class="question-text-content">
              <h3 v-html="questions[questionIndex].text"></h3>
            </div>
            <img class="next-button" src="~../assets/blue-next.png" @click="slideLeft" alt="Suivant">
          </div>
        </div>
        <div class="wave-right">
          <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
            <path d="M208.08,0.00 C600.69,67.09 0.02,75.98 200.80,150.00 L0.00,150.00 L0.00,0.00 Z"
                  style="stroke: none; fill: #fff;"></path>
          </svg>
        </div>
      </div>
      <div class="answer-container" :class="{'slide-left': isLeft}" v-show="currentStep === QUESTION">
        <div class="answer-text">
          <div class="choice-list">
            <div v-for="choice in questions[questionIndex].choices">
              <div class="answer" @click="answerPicked(choice)" v-html="choice.text"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="feedback-container" v-show="currentStep === FEEDBACK">
        <div class="feedback-content" v-if="currentStep === FEEDBACK"
             :class="{'incorrect': choicePicked.spine_skin !== 'pieuvre'}">
          <div class="feedback-text">
            <div class="feedback-text-content">
              <h3 v-html="choicePicked.feedback"></h3>
            </div>
            <img class="next-button"
                 src="~../assets/white-next.png"
                 @click="showNextQuestion" alt="Suivant">
          </div>
          <div class="wave-right">
            <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
              <path class="incorrect" d="M208.08,0.00 C600.69,67.09 0.02,75.98 200.80,150.00 L0.00,150.00 L0.00,0.00 Z"
                    style="stroke: none;"></path>
            </svg>
          </div>
        </div>
        <div id="spinePlayerFeedback" v-show="choicePicked && choicePicked.spine_project !== 'squid'">
        </div>
        <div id="spinePlayerFeedbackSquid" v-show="choicePicked && choicePicked.spine_project === 'squid'">
        </div>
      </div>
      <div class="intro-container" id="intro-container" v-if="currentStep === INTRO">
        <div class="header">
          <img src="/static/vendors/images/logo.png" alt="">
          <h1>Idées fraîches</h1>
          <p class="subtitle">Les écogestes pour une meilleure climatisation</p>
        </div>
        <div style="height: 150px; overflow: hidden;">
          <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
            <path d="M0.00,49.98 C149.99,150.00 271.49,-49.98 500.00,49.98 L500.00,0.00 L0.00,0.00 Z"
                  style="stroke: none; fill: #fff;"></path>
          </svg>
        </div>
        <div id="spinePlayerIntroSquid"></div>
        <div class="btn-container">
          <a class="results-button" @click.stop="startGame">Jouer</a>
        </div>
        <div class="footer">
          <img src="/static/vendors/images/CEE.png" alt="">
        </div>
      </div>
      <div class="results-container" v-if="currentStep === RESULT">
        <div class="results-content">
          <div class="score-badge">
            <img :src="scoreImg" alt="">
          </div>
          <h3 v-html="scoreMessageTitle"></h3>
          <p v-html="scoreMessage"></p>
          <a class="results-button" @click.stop="restartQuiz">Nouvelle Partie</a>
          <a class="results-button" href="/">Quitter</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '~../styles/index';

#serious {
  height: 100vh;
  width: 100%;
  background-color: #000000;
  overflow: hidden;
}
</style>

<style scoped lang="scss">
@font-face {
  font-family: 'ComicNeue';
  src: url('~../assets/ComicNeue-Regular.ttf') format('truetype');
}

@font-face {
  font-family: 'ComicNeueBold';
  src: url('~../assets/ComicNeue-Bold.ttf') format('truetype');
}

@font-face {
  font-family: 'CarroiGothicSC';
  src: url('~../assets/CarroisGothicSC-Regular.ttf') format('truetype');
}


$width: 1280px;
$height: 720px;

$color_bad: #c90427;
$light_blue: #0bacda;
$dark_blue: #0086b1;


.intro-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;

  width: $width;
  height: $height;

  background-image: url("~../../vendors/bg/Cuisine.jpg");
  background-size: 105%;
  background-position: 50% 50%;

  display: flex;
  flex-direction: column;


  .header, .footer {
    background-color: #fff;
    color: $dark_blue;
    text-align: center;
    padding-top: 15px;
    padding-bottom: 15px;

    h1, p {
      margin: 0;
    }

    h1 {
      text-transform: uppercase;
      font-family: CarroiGothicSC, sans-serif;
      font-weight: bold;
      font-size: 5rem;
    }

    p {
      font-size: 2rem;
    }

  }

  .btn-container {
    text-align: center;
    margin: 2rem;
    flex-grow: 1;

    display: flex;
    flex-direction: column-reverse;
    align-items: center;

    a {
      display: inline-block;
    }
  }

  #spinePlayerIntroSquid {
    position: absolute;
    z-index: 10;
    width: 850px;
    margin: auto;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -35%);

    pointer-events: none;
  }

  .footer {
    img {
      height: 40px;
    }
  }
}

.results-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;

  width: $width;
  height: $height;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-image: url('~../../vendors/images/Score.jpg');
  background-size: cover;

  .results-content {
    width: 45%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;

    padding: 2rem;

    h3 {
      color: $dark_blue;
    }

    p {
      font-size: 1.4rem;
      text-align: center;
      margin: 0 0 1rem 0;
      line-height: 1.6rem;
    }

    .score-badge {
      img {
        max-height: 220px;
      }
    }
  }
}

a {
  display: block;
  color: #fff;
  background-color: $light_blue;
  font-size: 1.5rem;
  font-family: 'ComicNeueBold', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  padding: .8rem 1.6rem;
  border-radius: 1.5rem;
  text-decoration: none;
  width: 300px;
  text-align: center;
  cursor: pointer;
}

.serious-page {
  //display: flex;
  //flex-direction: column;
  //align-items: center;
  //justify-content: center;
  background-color: #6aa1b2;
  //width: $width;
  //height: $height;
  font-family: 'ComicNeue', sans-serif;
}


.serious-page {
  width: $width;
  height: $height;
  padding: 0;
  margin: 0;
  position: relative;
  left: 50%;
  top: 50%;
  right: auto;
  bottom: auto;
  transform: translate3d(-50%, -50%, 0);
  transform-origin: center center;
  perspective: 600px;
  perspective-origin: 50% 40%;
  overflow: hidden;
  backface-visibility: hidden;
}

.next-button {
  max-height: 100px;
  cursor: pointer;
}

.container-game {
  width: $width;
  height: $height;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  position: relative;

  overflow: hidden;

  .question-container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: calc($width / 1.5);
    height: $height;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;

    //background-color: #f00;

    transform: translate3d(62%, 0, 0);
    transition: transform 0.5s ease-in-out;


    &.slide-left {
      transform: translate3d(-20%, 0, 0);

      .question .question-text {
        transform: translate(-42.5%, 0);
      }

      .next-button {
        transform: rotate3d(0, 1, 0, 180deg);
      }
    }

    .wave-left, .wave-right {
      width: 15%;
    }

    .wave-left {
      margin-right: -5px;
    }

    .wave-right {
      margin-left: -5px;
    }

    .question {
      background-color: #fff;
      flex: 1;
      position: relative;

      .question-text {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        transition: transform 0.5s ease-in-out;

        height: 100%;
        padding: 20px 10px;
        width: 95%;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        text-align: center;
        color: $dark_blue;

        .question-text-content {
          width: 100%;
          height: 480px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;


        }
      }

      .next-button {
        max-height: 110px;
        transition: transform 0.5s ease-in-out;
      }

    }
  }

  h3 {
    font-size: 2.05rem;
    font-family: ComicNeueBold, sans-serif;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .answer-container {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 5;
    width: calc($width / 1.86);
    height: $height;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    background-color: $light_blue;
    text-align: center;
    padding-left: 5%;

    transform: translate3d(10%, 0, 0);
    transition: transform 0.5s ease-in-out;

    .answer-text {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 1rem 3rem;

      .answer {
        background-color: #fff;
        color: $dark_blue;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2rem;
        line-height: 2.4rem;
        cursor: pointer;
        padding: 1.6rem;
        margin: 1.8rem 0;
        height: 160px;
        width: 550px;

        &:hover {
          background-color: #eee;
        }
      }
    }

    &.slide-left {
      transform: translate3d(0, 0, 0);
    }
  }

  .feedback-container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 15;
    width: $width;
    height: $height;
    display: flex;
    flex-direction: row;

    .feedback-content {
      width: 700px;
      height: $height;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      position: relative;
      z-index: 20;

      .feedback-text {
        background-color: $light_blue;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 620px;

        .feedback-text-content {
          width: 95%;
          height: 480px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          h3 {
            color: #fff;
            text-align: center;
          }
        }
      }

      path {
        fill: $light_blue;
      }


      &.incorrect {
        .feedback-text {
          background-color: $color_bad;
        }

        path {
          fill: $color_bad;
        }
      }

      .wave-right {
        margin-left: -5px;
        width: 80px;
      }
    }
  }
}


#spinePlayer, #spinePlayerFeedback, #spinePlayerFeedbackSquid {
  //width: 4000px;
  height: $height;
  position: relative;
  bottom: -100px;
  z-index: 1;
  pointer-events: none;
}

#spinePlayer {
  left: -360px;
}

#spinePlayerFeedback {
  right: -0px;
  width: 45%;
}

#spinePlayerFeedbackSquid {
  right: -330px;
  width: 100%;
  position: absolute;
}
</style>